import {Routes} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';

export const AppRoutes: Routes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            {
                path: '',
                redirectTo: 'authentication/login',
                pathMatch: 'full'
            },
            {
                path: 'authentication',
                loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
            }
        ]
    },
  {
    path: '',
    component: AdminComponent,
    children: [
       {
        path: 'dashboard',
        loadChildren: './pages/dashboard/dashboard.module#DashboardModule'
      }, {
            path: 'projet',
            loadChildren: './pages/projet/projet.module#ProjetModule'
        },
        {
            path: 'tache',
            loadChildren: './pages/tache/tache.module#TacheModule'
        },
        {
            path: 'ged',
            loadChildren: './pages/ged/ged.module#GedModule'
        },
        {
            path: 'administration',
            loadChildren: './pages/administration/administration.module#AdministrationModule'
        }
    ]
  }
];



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/app.routing.ts